<template>
  <div :style="{...wrapStyle}" @click="handleClickEvent()">
    <p :class="getCss('bind-btn-text')" :style="btnTextStyle" @click="showDialog()">{{ btnText }}</p>
    <modal :isShow="isShow"  v-transfer-dom >
      <div :class="getCss('modal')" :style="modalStyle">
        <div :class="getCss('btn-close')" :style="closeStyle" @click="closeDialog()">×</div>
        <div :class="getCss('head_text')" v-if="bindingCut" :style="titleStyle">绑定QQ号</div>
        <div :class="getCss('head_text')" v-else :style="titleStyle">绑定微信号</div>
        <!-- 未绑定 -->
        <template v-if="step === 1">
          <input
            type="text"
            :class="getCss('qq-input')"
            :style="inputStyle"
            v-model="currentQQ"
            v-if="bindingCut"
            placeholder="请输入QQ号"
          />
          <input
            type="text"
            :class="getCss('qq-input')"
            :style="inputStyle"
            v-model="currentWX"
            v-else
            placeholder="请输入微信号"
          />
          <p
            :class="getCss('tip')"
            :style="tipStyle"
            v-if="bindingCut"
          >{{ configurationData.modalConfig.submitBtnConfig.msg }}</p>
          <p
            :class="getCss('tip')"
            :style="tipStyle"
            v-else
          >{{ configurationData.modalConfig.submitBtnConfig.msgWx }}</p>
          <a
            href="javascript:void(0);"
            :class="getCss('modal-fotter-center-btn')"
            :style="submitBtnStyle"
            @click="submit()"
          ></a>
        </template>
        <!-- 二次确认 -->
        <template v-if="step === 2">
          <input
            type="text"
            :class="getCss('qq-input')"
            :style="inputStyle"
            v-model="currentQQ"
            v-if="bindingCut"
            placeholder="请输入QQ号"
          />
          <input
            type="text"
            :class="getCss('qq-input')"
            :style="inputStyle"
            v-model="currentWX"
            v-else
            placeholder="请输入微信号"
          />
          <p :class="getCss('tip')" v-if="bindingCut" :style="tipStyle">绑定QQ仅限一次，请确认提交的QQ号是否正确</p>
          <p :class="getCss('tip')" v-else :style="tipStyle">绑定微信仅限一次，请确认提交的微信号是否正确</p>

          <div :class="getCss('modal-fotter-control')" :style="confirmControlStyle">
            <a
              href="javascript:void(0);"
              :class="getCss('modal-fotter-control-btn')"
              :style="confirmControlLeftStyle"
              @click="confirm()"
            ></a>
            <a
              href="javascript:void(0);"
              :class="getCss('modal-fotter-control-btn')"
              :style="confirmControlRightStyle"
              @click="closeDialog()"
            ></a>
          </div>
        </template>
        <!-- 已绑定 -->
        <template v-if="step === 3">
          <p :class="getCss('tip')" v-if="bindingCut" :style="inputTipStyle">已绑定:{{ currentQQ }}</p>
          <p :class="getCss('tip')" v-else :style="inputTipStyle">已绑定:{{ currentWX }}</p>
          <p :class="getCss('tip')" v-if="bindingCut" :style="tipStyle">绑定QQ仅限一次</p>
          <p :class="getCss('tip')" v-else :style="tipStyle">绑定微信仅限一次</p>
          <a
            href="javascript:void(0);"
            :class="getCss('modal-fotter-center-btn')"
            :style="doneBtnStyle"
            @click="closeDialog()"
          ></a>
        </template>
      </div>
    </modal>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
import modal from './modal.vue';

export default {
  name: 'CPopupBindqq',
  components: {
    modal,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'popup-bindqq-',
      isShow: false,
      currentQQ: '',
      currentWX: '',
      step: 1,
    };
  },
  computed: {
    wrapStyle() {
      return {
        ...this.styles.base,
        background: `url(${this.configurationData.backgroundImage})`,
      };
    },
    btnTextStyle() {
      return {
        color: this.configurationData.btnColor,
        fontSize: this.configurationData.btnFontSize,
        textAlign: 'center',
        lineHeight: 'inherit',
      };
    },
    modalStyle() {
      return {
        width: `${this.configurationData.modalConfig.backgroundConfig.width}rem`,
        height: `${this.configurationData.modalConfig.backgroundConfig.height}rem`,
        color: this.configurationData.titleColor,
        background: `url(${this.configurationData.modalConfigBackgroundConfigImg}) no-repeat center/contain`,
      };
    },
    submitBtnStyle() {
      return {
        width: `${this.configurationData.modalConfig.submitBtnConfig.width}rem`,
        height: `${this.configurationData.modalConfig.submitBtnConfig.height}rem`,
        top: `${this.configurationData.modalConfig.submitBtnConfig.top}%`,
        background: `url(${this.configurationData.modalConfigSubmitBtnConfigImg}) no-repeat center/contain`,
      };
    },
    confirmControlStyle() {
      return {
        top: `${this.configurationData.modalConfig.confirmBtnConfig.top}%`,
      };
    },
    confirmControlLeftStyle() {
      return {
        width: `${this.configurationData.modalConfig.confirmBtnConfig.width}rem`,
        height: `${this.configurationData.modalConfig.confirmBtnConfig.height}rem`,
        background: `url(${this.configurationData.modalConfigConfirmBtnConfigleftImg}) no-repeat center/contain`,
      };
    },
    confirmControlRightStyle() {
      return {
        width: `${this.configurationData.modalConfig.confirmBtnConfig.width}rem`,
        height: `${this.configurationData.modalConfig.confirmBtnConfig.height}rem`,
        background: `url(${this.configurationData.modalConfigConfirmBtnConfigrightImg}) no-repeat center/contain`,
      };
    },
    doneBtnStyle() {
      return {
        width: `${this.configurationData.modalConfig.doneBtnConfig.width}rem`,
        height: `${this.configurationData.modalConfig.doneBtnConfig.height}rem`,
        top: `${this.configurationData.modalConfig.doneBtnConfig.top}%`,
        background: `url(${this.configurationData.modalConfigDoneBtnConfigImg}) no-repeat center/contain`,
      };
    },
    inputStyle() {
      return {
        width: `${this.configurationData.modalConfig.inputConfig.width}rem`,
        height: `${this.configurationData.modalConfig.inputConfig.height}rem`,
        lineHeight: `${this.configurationData.modalConfig.inputConfig.height}rem`,
        top: `${this.configurationData.modalConfig.inputConfig.top}%`,
        color: this.configurationData.inputColor,
        borderColor: this.configurationData.modalConfig.inputConfig.color,
        background: this.configurationData.modalConfig.inputConfig.backgroundColor,
      };
    },
    tipStyle() {
      return {
        width: `${this.configurationData.modalConfig.inputConfig.width}rem`,
        color: this.configurationData.textColor,
      };
    },
    inputTipStyle() {
      return {
        fontSize: '0.35rem',
        width: `${this.configurationData.modalConfig.backgroundConfig.width}rem`,
        height: `${this.configurationData.modalConfig.backgroundConfig.height}rem`,
        top: `${this.configurationData.modalConfig.inputConfig.top}%`,
        color: this.configurationData.textColor,
      };
    },
    titleStyle() {
      return {
        color: this.configurationData.titleColor,
      };
    },
    closeStyle() {
      return {
        color: this.configurationData.modalConfig.closeConfig.color,
      };
    },
    bindingCut() { // 绑定方式
      return this.configurationData.bindingCut;
    },
    btnText() { // 文字内容
      return this.configurationData.btnText;
    },
  },
  mounted() {
    console.log('configurationData=', this.configurationData);
    // console.log("this.btnText",this.configurationData.backgroundImage);
    // console.log(this.btnText);
    this.configurationData.backgroundImage ? this.btnText = '' : '';
    if (!this.configurationData.bindFlowID || !this.configurationData.checkFlowID) {
      return false;
    }
    this.initialize();
  },
  methods: {
    initialize() {
      this.$onLogined(async () => {
        const response = await this.flowRequest({ flowId: this.configurationData.checkFlowID });
        // console.log('查询', response);
        if (response.data.ret === 0) {
          if (this.bindingCut) { // qq
            const { account, bingingStatus } = response.data;
            this.currentQQ = account;
            if (bingingStatus === 1) {
              // 已经绑定
              this.step = 3;
            } else {
              this.step = 1;
            }
          } else { // wx
            const { account, bingingStatus } = response.data;
            this.currentWX = account;
            if (bingingStatus === 1) {
              // 已经绑定
              this.step = 3;
            } else {
              this.step = 1;
            }
          }
        } else {
          this.alert(response.msg);
        }
      });
      this.$eventBus.$on('package.address.fill', () => {
        this.showDialog();
      });
    },
    // binded(qq) {
    //   this.step = 3;
    //   this.currentQQ = qq;
    // },
    showDialog() {
      if (this.$isInEditor) return;
      // 强制登陆
      if (!this.isLogin) {
        if (window.CEIBA_ACTION_CHECK_EVENT_LOGIN) {
          this.$eventBus.$emit(window.CEIBA_ACTION_CHECK_EVENT_LOGIN);
          return;
        }
        this.alert({
          msg: '请先登录',
          confirm: () => {},
        });
        return;
      }
      this.handleClickEvent();
      // if (this.configurationData.isNeedInApp) {
      //   if (this.$ast.isAPP()) {
      //     this.isShow = true;
      //   } else {
      //     this.$ast.gotoAPP();
      //     return;
      //   }
      // }
      this.isShow = true;
    },
    closeDialog() {
      console.log(this.isShow);
      this.isShow = false;
    },
    submit() {
      const regQq = /^[1-9]\d{4,11}$/;
      const regWx = /^[a-zA-Z][a-zA-Z\d_-]{5,19}$/;
      if (this.bindingCut) {
        console.log('this.currentQQ=', this.currentQQ);
        if (!regQq.test(this.currentQQ)) {
          this.alert('请正确输出QQ号');
          return false;
        }
        this.step = 2;
      } else {
        console.log('this.currentWX=', this.currentWX);
        if (!regWx.test(this.currentWX)) {
          this.alert('请正确输出微信号');
          return false;
        }
        this.step = 2;
      }
    },
    async confirm() {
      if (this.configurationData.isNeedInApp && !this.$ast.isAPP()) {
        this.$ast.gotoAPP();
        return false;
      }
      console.log('bindingCut 为：', this.bindingCut);
      if (this.bindingCut) {
        if (!this.configurationData.bindFlowID) {
          this.alert('绑定流程id未配置');
          this.reportClickRaw({
            ceibaComponentId: `${this.cid}`,
            ceibaComponentUid: this.uid,
            ceibaComponentUname: this.uname,
            eventKey: 'bind_qq',
            eventData: {
              status: '0',
            },
          });
          return;
        }
        const response = await this.flowRequest({
          flowId: this.configurationData.bindFlowID,
          params: {
            data: JSON.stringify({ account: this.currentQQ }),
          },
        });
        if (response.data.ret === 0) {
          this.alert('绑定成功');
          this.closeDialog();
          this.step = 3;
          this.$eventBus.$emit('moudle.package.refresh');
          this.reportClickRaw({
            ceibaComponentId: `${this.cid}`,
            ceibaComponentUid: this.uid,
            ceibaComponentUname: this.uname,
            eventKey: 'bind_qq',
            eventData: {
              status: '1',
            },
          });
        } else {
          this.alert(response.msg);
          this.reportClickRaw({
            ceibaComponentId: `${this.cid}`,
            ceibaComponentUid: this.uid,
            ceibaComponentUname: this.uname,
            eventKey: 'bind_qq',
            eventData: {
              status: '0',
            },
          });
        }
      } else { // wx
        const response = await this.flowRequest({
          flowId: this.configurationData.bindFlowID,
          params: {
            data: JSON.stringify({ account: this.currentWX }),
          },
        });
        if (response.data.ret === 0) {
          this.alert('绑定成功');
          this.closeDialog();
          this.step = 3;
          this.$eventBus.$emit('moudle.package.refresh');
          this.reportClickRaw({
            ceibaComponentId: `${this.cid}`,
            ceibaComponentUid: this.uid,
            ceibaComponentUname: this.uname,
            eventKey: 'bind_wx',
            eventData: {
              status: '1',
            },
          });
        } else {
          this.alert(response.msg);
          this.reportClickRaw({
            ceibaComponentId: `${this.cid}`,
            ceibaComponentUid: this.uid,
            ceibaComponentUname: this.uname,
            eventKey: 'bind_wx',
            eventData: {
              status: '0',
            },
          });
        }
      }
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
